import { useState, useEffect, useCallback } from 'react';
import api from '../api/client';
import { useAuth } from '../context/AuthContext';
import CardGrid from '../components/CardGrid';
import Header from './Header'
import "./Favorite.css"

export default function Favorite({ translations }) {
    const { user } = useAuth();
    const [pictures, setPictures] = useState([]);
    const [loading, setLoading] = useState(true);
    const [tab, setTab] = useState('liked');

    const fetchPictures = useCallback(async () => {
        setLoading(true);
        try {
            let data;
            if (tab === 'following' && user) {
                data = await api.getFollowingUploads(0, 40);
            } else if (tab === 'liked' && user) {
                data = await api.getLikedPictures(0, 40);
            }
            setPictures(Array.isArray(data) ? data : []);
        } catch {
            setPictures([]);
        } finally {
            setLoading(false);
        }
    }, [tab, user]);

    useEffect(() => {
        fetchPictures();
    }, [fetchPictures]);

    return (
        <div>
            <Header translations={translations} />
            <div className="feed-page">

            {user && (
                <div className="feed-tabs">
                    <button className={`feed-tab ${tab === 'liked' ? 'active' : ''}`} onClick={() => setTab('liked')}>
                        {translations['favorite-tab-liked']}
                    </button>
                    <button className={`feed-tab ${tab === 'following' ? 'active' : ''}`} onClick={() => setTab('following')}>
                        {translations['favorite-tab-following']}
                    </button>
                </div>
            )}

            {loading ? (
                <div className="loading-page"><div className="spinner" /></div>
            ) : (
                <CardGrid pictures={pictures} />
            )}
            </div>
        </div>
    );
}
